<template>
  <div class="toggle-radio-card-list-section">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * ラジオ選択カードリスト セクション
 */
export default defineComponent({
  name: 'ToggleRadioCardListSection',
  components: {},
  props: {},
})
</script>

<style lang="scss" scoped>
.toggle-radio-card-list-section {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
}
</style>
